// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subheader {
    display: flex;
    flex-direction: column;
}
.fleet_manage {
    width: 240px;
    height: calc(100vh - 80px - 60px);
    background: #FFFFFF;
    border-right: 1px solid #E0E3E8;
    scrollbar-width: none;
    overflow-y: scroll;
}
.fleet_manage {
    scrollbar-width: none;
   -ms-overflow-style: none;
 }
 
 .fleet_manage::-webkit-scrollbar {
   display: none;
 }
.fleet_manage_title {
    font-weight: 600;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0.01em;
    margin-left: 0.7vw;
    margin-top: 1vh;
    color: #303239;
}
.fleet_maange_state_level {
    padding: 0.7vw;
    background: #FFFFFF;
    border-width: 0px 1px 1px 0px;
    border-style: solid;
    border-color: #E0E3E8;
    display: flex;
    justify-content: space-between;
}

.fleet_manage_state_level_name {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #303239;
}
.fleet_management_level_one {
    /* display: none; */
    transition: 900ms all ease-in-out;
}

.toggle_homepage_mapview {
    background-color: #F4F4F4;
    display: flex;
    margin-top: 1.1vh;
    margin-bottom: 1.1vh;
    justify-content: center;
    align-items: center;
    box-shadow: 20px 4px 24px rgba(0, 0, 0, 0.02);
    height: 42px;
    color: #828799;
    

  }
  .dashboard_toggle, .mapview_toggle {
    
    margin-left: 1vw;
    margin-right: .5v;
    padding-left: 1vw;
    padding-right: 1vw;
   
    padding-bottom: 1vh;
    display: flex;
    cursor: pointer;
    transition: 500ms all ease-in-out;
    width: 124px;
    height: 22px;
    text-align: center;
    align-items: center;
    
    
  }
  /* .dashboard_toggle:hover, .mapview_toggle:hover  {
    background-color: #A9C86A;
  } */
  .mapview_toggle {
    margin-right: 1vw;
 
  }
  .dashboardview_text,.mapview_text {
    margin-left: .5vw;
    font-weight: 400;
    font-size: 14px;
    /* margin-top: .5vh; */
    transform: translateY(5px);
    
  }
.subheader_logo{
  transform: translateY(5px);
}

  .subheader_dash {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-around;
    padding-left: 20px;
    padding-right: 20px;
    border-bottom: 1px solid #E0E3E8;
    
}
.subheader_right_row{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    gap: 50px;
    /* border: 1px solid green; */

}
.subheader_inputs{
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    gap: 10px;
    /* width: 300px; */
    /* border: 2px solid red; */
}
.subheader_header_text{
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  width: 50vw;
}
.empty_subheader{
  width: 80%;
  height: 63px;
}
.listItemHome:hover + .showTextHome{
  display: block;
}
.showTextHome{
  display: none;
  color: white;
  background-color:black;
  position: absolute;
  left: 85px;
  top: 19px;
  padding: 4px;
  /* opacity: 70%; */
}
.showTextHome::before,
.showTextHome::after {
  content: '';
  position: absolute;
  bottom: 100%;
  left: -12px;
  top:9px;
  border: 6px solid transparent;
  border-right-color: black;
  /* opacity: 70%; */
}

.showTextHome::after {
  left: -12px;
  top:9px;
  border:6px solid transparent;
  border-right-color: black;
  /* opacity: 70%; */
}
.listItemSoftwareUpgrade:hover + .showTextSoftwareUpgrade{
  display: block;
}
.showTextSoftwareUpgrade{
  display: none;
  color: white;
  background-color:black;
  width:max-content;
  position: absolute;
  left: 85px;
  top: 72px;
  padding: 4px;
  /* opacity: 70%; */
}
.showTextSoftwareUpgrade::before,
.showTextSoftwareUpgrade::after {
  content: '';
  position: absolute;
  bottom: 100%;
  left: -12px;
  top: 9px;
  border: 6px solid transparent;
  border-right-color: black;
  /* opacity: 70%; */
}

.showTextSoftwareUpgrade::after {
  left: -12px;
  top: 9px;
  border:6px solid transparent;
  border-right-color: black;
  /* opacity: 70%; */
}


.listItemFota:hover + .showTextFota{
  display: block;
}
.showTextFota{
  display: none;
  color: white;
  background-color:black;
  width:max-content;
  position: absolute;
  left: 85px;
  top: 250px;
  padding: 4px;
  /* opacity: 70%; */
}
.showTextFota::before,
.showTextFota::after {
  content: '';
  position: absolute;
  bottom: 100%;
  left: -12px;
  top: 9px;
  border: 6px solid transparent;
  border-right-color: black;
  /* opacity: 70%; */
}

.showTextFota::after {
  left: -12px;
  top: 9px;
  border:6px solid transparent;
  border-right-color: black;
  /* opacity: 70%; */
}

.showTextFeatureConfigurations{
  display: none;
  color: white;
  background-color:black;
  width:max-content;
  position: absolute;
  left: 85px;
  top: 190px;
  padding: 4px;
}
.listItemFeatureConfigurations:hover + .showTextFeatureConfigurations{
  display: block;
}

.showTextFeatureConfigurations::before,
.showTextFeatureConfigurations::after {
  content: '';
  position: absolute;
  bottom: 100%;
  left: -12px;
  top: 9px;
  border: 6px solid transparent;
  border-right-color: black;
  /* opacity: 70%; */
}

.showTextFeatureConfigurations::after {
  left: -12px;
  top: 9px;
  border:6px solid transparent;
  border-right-color: black;
  /* opacity: 70%; */
}

.listItemVehicleScan:hover + .showTextVehicleScan{
  display: block;
}

.showTextVehicleScan{
  display: none;
  color: white;
  background-color:black;
  width:max-content;
  position: absolute;
  left: 85px;
  top: 130px;
  padding: 4px;
  /* opacity: 70%; */
}
.showTextVehicleScan::before,
.showTextVehicleScan::after {
  content: '';
  position: absolute;
  bottom: 100%;
  left: -12px;
  top: 9px;
  border: 6px solid transparent;
  border-right-color: black;
  /* opacity: 70%; */
}

.listItemReport:hover + .showTextReport{
  display: block;
}

.showTextReport{
  display: none;
  color: white;
  background-color:black;
  width:max-content;
  position: absolute;
  left: 85px;
  top: 72px;
  padding: 4px;
  /* opacity: 70%; */
}
.showTextReport::before,
.showTextReport::after {
  content: '';
  position: absolute;
  bottom: 100%;
  left: -12px;
  top: 9px;
  border: 6px solid transparent;
  border-right-color: black;
  /* opacity: 70%; */
}
.listItemOta4:hover + .showTextOta4{
  display: block;
}

.showTextOta4{
  display: none;
  color: white;
  background-color:black;
  width:max-content;
  position: absolute;
  left: 85px;
  top: 310px;
  padding: 4px;
  /* opacity: 70%; */
}
.showTextOta4::before,
.showTextOta4::after {
  content: '';
  position: absolute;
  bottom: 100%;
  left: -12px;
  top: 9px;
  border: 6px solid transparent;
  border-right-color: black;
  /* opacity: 70%; */
}
`, "",{"version":3,"sources":["webpack://./src/Components/Headers/MainSideBar.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;AAC1B;AACA;IACI,YAAY;IACZ,iCAAiC;IACjC,mBAAmB;IACnB,+BAA+B;IAC/B,qBAAqB;IACrB,kBAAkB;AACtB;AACA;IACI,qBAAqB;GACtB,wBAAwB;CAC1B;;CAEA;GACE,aAAa;CACf;AACD;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;IACf,cAAc;AAClB;AACA;IACI,cAAc;IACd,mBAAmB;IACnB,6BAA6B;IAC7B,mBAAmB;IACnB,qBAAqB;IACrB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;AACA;IACI,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,iBAAiB;IACjB,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB;IACnB,6CAA6C;IAC7C,YAAY;IACZ,cAAc;;;EAGhB;EACA;;IAEE,gBAAgB;IAChB,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;;IAElB,mBAAmB;IACnB,aAAa;IACb,eAAe;IACf,iCAAiC;IACjC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;;;EAGrB;EACA;;KAEG;EACH;IACE,iBAAiB;;EAEnB;EACA;IACE,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;IACf,sBAAsB;IACtB,0BAA0B;;EAE5B;AACF;EACE,0BAA0B;AAC5B;;EAEE;IACE,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;IAClB,mBAAmB;IACnB,gCAAgC;;AAEpC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,WAAW;IACX,SAAS;IACT,6BAA6B;;AAEjC;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,2BAA2B;IAC3B,SAAS;IACT,kBAAkB;IAClB,2BAA2B;AAC/B;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,WAAW;AACb;AACA;EACE,UAAU;EACV,YAAY;AACd;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,OAAO;EACP,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,OAAO;EACP,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;AACpB;;;AAGA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;AACd;AACA;EACE,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,QAAQ;EACR,4BAA4B;EAC5B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,YAAY;EACZ,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;AACpB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,YAAY;EACZ,kBAAkB;AACpB;AACA;;EAEE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,6BAA6B;EAC7B,yBAAyB;EACzB,kBAAkB;AACpB","sourcesContent":[".subheader {\r\n    display: flex;\r\n    flex-direction: column;\r\n}\r\n.fleet_manage {\r\n    width: 240px;\r\n    height: calc(100vh - 80px - 60px);\r\n    background: #FFFFFF;\r\n    border-right: 1px solid #E0E3E8;\r\n    scrollbar-width: none;\r\n    overflow-y: scroll;\r\n}\r\n.fleet_manage {\r\n    scrollbar-width: none;\r\n   -ms-overflow-style: none;\r\n }\r\n \r\n .fleet_manage::-webkit-scrollbar {\r\n   display: none;\r\n }\r\n.fleet_manage_title {\r\n    font-weight: 600;\r\n    font-size: 14px;\r\n    line-height: 24px;\r\n    letter-spacing: 0.01em;\r\n    margin-left: 0.7vw;\r\n    margin-top: 1vh;\r\n    color: #303239;\r\n}\r\n.fleet_maange_state_level {\r\n    padding: 0.7vw;\r\n    background: #FFFFFF;\r\n    border-width: 0px 1px 1px 0px;\r\n    border-style: solid;\r\n    border-color: #E0E3E8;\r\n    display: flex;\r\n    justify-content: space-between;\r\n}\r\n\r\n.fleet_manage_state_level_name {\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    line-height: 24px;\r\n    color: #303239;\r\n}\r\n.fleet_management_level_one {\r\n    /* display: none; */\r\n    transition: 900ms all ease-in-out;\r\n}\r\n\r\n.toggle_homepage_mapview {\r\n    background-color: #F4F4F4;\r\n    display: flex;\r\n    margin-top: 1.1vh;\r\n    margin-bottom: 1.1vh;\r\n    justify-content: center;\r\n    align-items: center;\r\n    box-shadow: 20px 4px 24px rgba(0, 0, 0, 0.02);\r\n    height: 42px;\r\n    color: #828799;\r\n    \r\n\r\n  }\r\n  .dashboard_toggle, .mapview_toggle {\r\n    \r\n    margin-left: 1vw;\r\n    margin-right: .5v;\r\n    padding-left: 1vw;\r\n    padding-right: 1vw;\r\n   \r\n    padding-bottom: 1vh;\r\n    display: flex;\r\n    cursor: pointer;\r\n    transition: 500ms all ease-in-out;\r\n    width: 124px;\r\n    height: 22px;\r\n    text-align: center;\r\n    align-items: center;\r\n    \r\n    \r\n  }\r\n  /* .dashboard_toggle:hover, .mapview_toggle:hover  {\r\n    background-color: #A9C86A;\r\n  } */\r\n  .mapview_toggle {\r\n    margin-right: 1vw;\r\n \r\n  }\r\n  .dashboardview_text,.mapview_text {\r\n    margin-left: .5vw;\r\n    font-weight: 400;\r\n    font-size: 14px;\r\n    /* margin-top: .5vh; */\r\n    transform: translateY(5px);\r\n    \r\n  }\r\n.subheader_logo{\r\n  transform: translateY(5px);\r\n}\r\n\r\n  .subheader_dash {\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: space-around;\r\n    padding-left: 20px;\r\n    padding-right: 20px;\r\n    border-bottom: 1px solid #E0E3E8;\r\n    \r\n}\r\n.subheader_right_row{\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    width: 100%;\r\n    gap: 50px;\r\n    /* border: 1px solid green; */\r\n\r\n}\r\n.subheader_inputs{\r\n    display: flex;\r\n    flex-direction: row;\r\n    align-items: center;\r\n    justify-content: flex-start;\r\n    gap: 10px;\r\n    /* width: 300px; */\r\n    /* border: 2px solid red; */\r\n}\r\n.subheader_header_text{\r\n  font-style: normal;\r\n  font-weight: 600;\r\n  font-size: 20px;\r\n  width: 50vw;\r\n}\r\n.empty_subheader{\r\n  width: 80%;\r\n  height: 63px;\r\n}\r\n.listItemHome:hover + .showTextHome{\r\n  display: block;\r\n}\r\n.showTextHome{\r\n  display: none;\r\n  color: white;\r\n  background-color:black;\r\n  position: absolute;\r\n  left: 85px;\r\n  top: 19px;\r\n  padding: 4px;\r\n  /* opacity: 70%; */\r\n}\r\n.showTextHome::before,\r\n.showTextHome::after {\r\n  content: '';\r\n  position: absolute;\r\n  bottom: 100%;\r\n  left: -12px;\r\n  top:9px;\r\n  border: 6px solid transparent;\r\n  border-right-color: black;\r\n  /* opacity: 70%; */\r\n}\r\n\r\n.showTextHome::after {\r\n  left: -12px;\r\n  top:9px;\r\n  border:6px solid transparent;\r\n  border-right-color: black;\r\n  /* opacity: 70%; */\r\n}\r\n.listItemSoftwareUpgrade:hover + .showTextSoftwareUpgrade{\r\n  display: block;\r\n}\r\n.showTextSoftwareUpgrade{\r\n  display: none;\r\n  color: white;\r\n  background-color:black;\r\n  width:max-content;\r\n  position: absolute;\r\n  left: 85px;\r\n  top: 72px;\r\n  padding: 4px;\r\n  /* opacity: 70%; */\r\n}\r\n.showTextSoftwareUpgrade::before,\r\n.showTextSoftwareUpgrade::after {\r\n  content: '';\r\n  position: absolute;\r\n  bottom: 100%;\r\n  left: -12px;\r\n  top: 9px;\r\n  border: 6px solid transparent;\r\n  border-right-color: black;\r\n  /* opacity: 70%; */\r\n}\r\n\r\n.showTextSoftwareUpgrade::after {\r\n  left: -12px;\r\n  top: 9px;\r\n  border:6px solid transparent;\r\n  border-right-color: black;\r\n  /* opacity: 70%; */\r\n}\r\n\r\n\r\n.listItemFota:hover + .showTextFota{\r\n  display: block;\r\n}\r\n.showTextFota{\r\n  display: none;\r\n  color: white;\r\n  background-color:black;\r\n  width:max-content;\r\n  position: absolute;\r\n  left: 85px;\r\n  top: 250px;\r\n  padding: 4px;\r\n  /* opacity: 70%; */\r\n}\r\n.showTextFota::before,\r\n.showTextFota::after {\r\n  content: '';\r\n  position: absolute;\r\n  bottom: 100%;\r\n  left: -12px;\r\n  top: 9px;\r\n  border: 6px solid transparent;\r\n  border-right-color: black;\r\n  /* opacity: 70%; */\r\n}\r\n\r\n.showTextFota::after {\r\n  left: -12px;\r\n  top: 9px;\r\n  border:6px solid transparent;\r\n  border-right-color: black;\r\n  /* opacity: 70%; */\r\n}\r\n\r\n.showTextFeatureConfigurations{\r\n  display: none;\r\n  color: white;\r\n  background-color:black;\r\n  width:max-content;\r\n  position: absolute;\r\n  left: 85px;\r\n  top: 190px;\r\n  padding: 4px;\r\n}\r\n.listItemFeatureConfigurations:hover + .showTextFeatureConfigurations{\r\n  display: block;\r\n}\r\n\r\n.showTextFeatureConfigurations::before,\r\n.showTextFeatureConfigurations::after {\r\n  content: '';\r\n  position: absolute;\r\n  bottom: 100%;\r\n  left: -12px;\r\n  top: 9px;\r\n  border: 6px solid transparent;\r\n  border-right-color: black;\r\n  /* opacity: 70%; */\r\n}\r\n\r\n.showTextFeatureConfigurations::after {\r\n  left: -12px;\r\n  top: 9px;\r\n  border:6px solid transparent;\r\n  border-right-color: black;\r\n  /* opacity: 70%; */\r\n}\r\n\r\n.listItemVehicleScan:hover + .showTextVehicleScan{\r\n  display: block;\r\n}\r\n\r\n.showTextVehicleScan{\r\n  display: none;\r\n  color: white;\r\n  background-color:black;\r\n  width:max-content;\r\n  position: absolute;\r\n  left: 85px;\r\n  top: 130px;\r\n  padding: 4px;\r\n  /* opacity: 70%; */\r\n}\r\n.showTextVehicleScan::before,\r\n.showTextVehicleScan::after {\r\n  content: '';\r\n  position: absolute;\r\n  bottom: 100%;\r\n  left: -12px;\r\n  top: 9px;\r\n  border: 6px solid transparent;\r\n  border-right-color: black;\r\n  /* opacity: 70%; */\r\n}\r\n\r\n.listItemReport:hover + .showTextReport{\r\n  display: block;\r\n}\r\n\r\n.showTextReport{\r\n  display: none;\r\n  color: white;\r\n  background-color:black;\r\n  width:max-content;\r\n  position: absolute;\r\n  left: 85px;\r\n  top: 72px;\r\n  padding: 4px;\r\n  /* opacity: 70%; */\r\n}\r\n.showTextReport::before,\r\n.showTextReport::after {\r\n  content: '';\r\n  position: absolute;\r\n  bottom: 100%;\r\n  left: -12px;\r\n  top: 9px;\r\n  border: 6px solid transparent;\r\n  border-right-color: black;\r\n  /* opacity: 70%; */\r\n}\r\n.listItemOta4:hover + .showTextOta4{\r\n  display: block;\r\n}\r\n\r\n.showTextOta4{\r\n  display: none;\r\n  color: white;\r\n  background-color:black;\r\n  width:max-content;\r\n  position: absolute;\r\n  left: 85px;\r\n  top: 310px;\r\n  padding: 4px;\r\n  /* opacity: 70%; */\r\n}\r\n.showTextOta4::before,\r\n.showTextOta4::after {\r\n  content: '';\r\n  position: absolute;\r\n  bottom: 100%;\r\n  left: -12px;\r\n  top: 9px;\r\n  border: 6px solid transparent;\r\n  border-right-color: black;\r\n  /* opacity: 70%; */\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
